import { OptionType } from "modules/common";
import { ValueType } from "react-select";

export const DEFAULT_PAGE_SIZE_OPTION: OptionType<string> = {
    value: "10",
    label: "10",
};

export const handlePageSizeChange = (
    value: ValueType<OptionType, false>,
    optionSetter: React.Dispatch<React.SetStateAction<OptionType<string>>>,
    currentPageSetter: React.Dispatch<React.SetStateAction<number>>
) => {
    optionSetter(value ?? DEFAULT_PAGE_SIZE_OPTION);
    currentPageSetter(1);
};

export const handlePageClick = (
    event: React.MouseEvent<HTMLSpanElement, MouseEvent>,
    currentPageSetter: React.Dispatch<React.SetStateAction<number>>
) => {
    currentPageSetter(Number(parseInt(event.currentTarget.id)));
};